import { CookieOptions } from 'ngx-cookie';

export function cookieOptionsFactory(): CookieOptions {
  return {
    path: '/',
    domain: window.location.hostname.match(/freelancer.*$/)
      ? `.${(<string[]>window.location.hostname.match(/freelancer.*$/))[0]}`
      : `${window.location.hostname}`,
    secure: window.location.protocol === 'https',
  };
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/pl/webapp/src/app/cookie-options.factory.ts